import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { SITE } from "@/constants/testIds";

const CONTACT_EMAIL = "contact@shabbatshalomamerica.com";

export const Footer = () => {
  return (
    <footer
      data-testid={SITE.footer}
      className="border-t border-border/60 bg-background py-16"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5">
            <span className="inline-flex w-2 h-2 rounded-full bg-primary glow-pulse" />
            <span className="font-serif text-xl text-foreground">
              Shabbat Shalom, <span className="text-primary">America</span>
            </span>
          </div>
          <p className="mt-5 text-sm text-foreground/55 leading-relaxed max-w-sm">
            A Jewish-American song of gratitude for America&apos;s 250th
            anniversary. Words &amp; music by Polina Rachel Furman.
          </p>
          <p className="mt-5 text-xs text-foreground/45 leading-relaxed max-w-sm">
            A project under the{" "}
            <span className="text-primary/90 font-medium tracking-wide">Shabbat250</span>{" "}
            initiative.
          </p>
          <div className="mt-6 flex flex-wrap gap-x-4 gap-y-2 text-[10px] uppercase tracking-[0.24em] text-primary/70">
            <span>#Shabbat250</span>
            <span>#ShabbatShalomAmerica</span>
            <span>#LightYourCandle</span>
          </div>
        </div>

        <div className="md:col-span-3">
          <p className="text-[11px] uppercase tracking-[0.28em] text-foreground/45 mb-4">
            Contact
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="inline-flex items-center gap-2 text-foreground/80 hover:text-primary transition-colors duration-300 text-sm"
          >
            <Mail className="w-3.5 h-3.5" strokeWidth={1.5} />
            {CONTACT_EMAIL}
          </a>
        </div>

        <div className="md:col-span-4">
          <p className="text-[11px] uppercase tracking-[0.28em] text-foreground/45 mb-4">
            Explore
          </p>
          <ul className="space-y-2.5 text-sm">
            <li>
              <a href="/#story" className="text-foreground/70 hover:text-primary transition-colors">
                The Story Behind the Song
              </a>
            </li>
            <li>
              <a href="/#listen" className="text-foreground/70 hover:text-primary transition-colors">
                Listen to the Preview
              </a>
            </li>
            <li>
              <a href="/#join" className="text-foreground/70 hover:text-primary transition-colors">
                Join the Release List
              </a>
            </li>
            <li>
              <Link
                to="/source-notes"
                data-testid={SITE.footerSourceNotesLink}
                className="text-foreground/70 hover:text-primary transition-colors"
              >
                Source Notes &amp; Inspiration
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12 mt-14 pt-8 border-t border-border/40">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6 text-xs text-foreground/45 leading-relaxed">
          <p>
            © {new Date().getFullYear()} Polina Rachel Furman. All rights reserved.
          </p>
          <p className="max-w-xl md:text-right">
            The current preview is an early AI-assisted demo recording. A
            professionally produced final version is in development.
          </p>
        </div>
      </div>
    </footer>
  );
};
